export default __webpack_public_path__ + "static/media/Free Legal Documents, Advice, Contracts & Forms - Logo.95a0df6e.png";